<document-lines-editor
  #lineGrid
  [columnDefs]="columnDefs"
  [rows]="lines()"
  [getContextMenuItems]="getContextMenuItems"
  [isDialogBox]="true"
  [rowClassRules]="rowClassRules"
  [fillRemainingHeight]="false"
  [domLayout]="'autoHeight'"
>
</document-lines-editor>
